import React, { useState } from 'react';

const ConstrainedSliders = (sliderCount, maxTotal) => {
  const [values, setValues] = useState(Array(sliderCount).fill(0.6)); // e.g., total = 3

  const handleChange = (index, newValue) => {
    const newValues = [...values];
    newValues[index] = newValue;

    let total = newValues.reduce((sum, val) => sum + val, 0);
    if (total > maxTotal) {
      const overflow = total - maxTotal;
      // Reduce others proportionally to fix the overflow
      const adjustableIndexes = newValues.map((val, i) => i !== index ? val : 0);
      const adjustableTotal = adjustableIndexes.reduce((a, b) => a + b, 0);

      for (let i = 0; i < sliderCount; i++) {
        if (i === index || adjustableTotal === 0) continue;
        const share = newValues[i] / adjustableTotal;
        newValues[i] -= share * overflow;
        newValues[i] = Math.max(0, newValues[i]); // Clamp to 0
      }
    }

    setValues(newValues);
  };

  const getMaxForSlider = (index) => {
    const totalWithoutCurrent = values.reduce((sum, val, i) => i === index ? sum : sum + val, 0);
    return Math.min(1, maxTotal - totalWithoutCurrent);
  };

  return (
    <div className="p-4 space-y-6">
      {values.map((value, index) => (
        <div key={index}>
          <label>Slider {index + 1}: {value.toFixed(2)}</label>
          <input
            type="range"
            min={0}
            max={getMaxForSlider(index)}
            step={0.01}
            value={value}
            onChange={(e) => handleChange(index, parseFloat(e.target.value))}
          />
        </div>
      ))}
      <div>Total: {values.reduce((sum, v) => sum + v, 0).toFixed(2)} / {maxTotal}</div>
    </div>
  );
};

export default ConstrainedSliders;